import Title from './src/title.vue'
import { withInstall } from '@el-plus/utils/with-install'

export const EpTitle = withInstall(Title)
export default EpTitle
export * from './src/title'

